import React from 'react';

import { FormattedMessage, useIntl } from 'react-intl';

import messages from './TechnicalError.messages';

const TechnicalError = ({ isIntroducer }) => {
    const intl = useIntl();

    return !isIntroducer ? (
        <>
            <div className="title-text">
                <FormattedMessage {...messages.title} />
            </div>
            <div className="content-text" data-testid="error-details-text">
                <FormattedMessage
                    {...messages.message}
                    values={{
                        phoneLink: (
                            <a
                                href={`tel:${intl
                                    .formatMessage(messages.phoneNumber)
                                    .replaceAll(' ', '')
                                    .replaceAll('/', '')}`}>
                                <FormattedMessage {...messages.phoneNumber} />
                            </a>
                        )
                    }}></FormattedMessage>
            </div>
        </>
    ) : (
        <>
            <div className="title-text">
                <FormattedMessage {...messages.introducerTitle} />
            </div>
            <div className="content-text" data-testid="error-details-text">
                <FormattedMessage
                    {...messages.introducerMessage1}
                    values={{
                        a: (chunks) => <a href="/introducer/portal">{chunks}</a>
                    }}></FormattedMessage>
            </div>
            <div className="content-text" data-testid="error-details-text-2">
                <FormattedMessage
                    {...messages.introducerMessage2}
                    values={{
                        phoneLink: (
                            <a
                                href={`tel:${intl
                                    .formatMessage(
                                        messages.phoneNumber_introducer
                                    )
                                    .replaceAll(' ', '')
                                    .replaceAll('/', '')}`}>
                                <FormattedMessage
                                    {...messages.phoneNumber_introducer}
                                />
                            </a>
                        ),
                        mailLink: (
                            <a
                                href={`mailto:${intl.formatMessage(
                                    messages.email
                                )}`}>
                                <FormattedMessage {...messages.email} />
                            </a>
                        )
                    }}></FormattedMessage>
            </div>
        </>
    );
};

export default TechnicalError;
